// src/pages/Chat/EmojiPicker.jsx
import React, { useEffect, useRef, useState, useCallback } from "react";
import { FiSearch, FiChevronRight } from "react-icons/fi";

const EMOJI_DATA = [
  {
    category: "Smileys",
    icon: "😀",
    emojis: ["😀","😃","😄","😁","😆","😅","😂","🤣","😊","😇","🙂","🙃","😉","😌","😍","🥰","😘","😗","😙","😚","😋","😛","😝","😜","🤪","🤨","🧐","🤓","😎","🤩","🥳","😏","😒","😞","😔","😟","😕","🙁","☹️","😣","😖","😫","😩","🥺","😢","😭","😤","😠","😡","🤬","🤯","😳","🥵","🥶","😱","😨","😰","😥","😓","🤗","🤔","🤭","🤫","🤥","😶","😐","😑","😬","🙄","😯","😦","😧","😮","😲","🥱","😴","🤤","😪","😵","🤐","🥴","🤢","🤮","🤧","😷","🤒","🤕","🤑","🤠","😈","👿","👹","👺","🤡","💩","👻","💀","☠️","👽","👾","🤖","🎃","😺","😸","😻","😼","😽","🙀","😿","😾"]
  },
  {
    category: "People",
    icon: "👋",
    emojis: ["👋","🤚","🖐️","✋","🖖","👌","🤏","✌️","🤞","🤟","🤘","🤙","👈","👉","👆","🖕","👇","☝️","👍","👎","✊","👊","🤛","🤜","👏","🙌","👐","🤲","🤝","🙏","✍️","💅","🤳","💪","🦾","🦵","🦿","🦶","👂","🦻","👃","🧠","🦷","🦴","👀","👁️","👅","👄","👶","👧","🧒","👦","👩","🧑","👨","👩‍🦱","🧑‍🦱","👨‍🦱","👩‍🦰","🧑‍🦰","👨‍🦰","👱‍♀️","👱","👱‍♂️","👩‍🦳","🧑‍🦳","👨‍🦳","👩‍🦲","🧑‍🦲","👨‍🦲","🧔","👵","🧓","👴","👲","👳‍♀️","👳","👳‍♂️","🧕","👰","🤵","🤰","🤱"]
  },
  {
    category: "Animals",
    icon: "🐶",
    emojis: ["🐶","🐱","🐭","🐹","🐰","🦊","🐻","🐼","🐨","🐯","🦁","🐮","🐷","🐽","🐸","🐵","🙈","🙉","🙊","🐒","🦍","🦧","🐕","🦮","🐩","🐺","🦝","🐈","🦁","🐯","🐆","🐴","🐎","🦄","🦓","🦌","🦬","🐮","🐂","🐃","🐄","🐗","🐑","🐐","🐪","🐫","🦙","🦒","🐘","🦣","🦏","🦛","🐭","🐁","🐀","🐹","🐰","🐇","🐿️","🦫","🦔","🐻","🐨","🐼","🦥","🦦","🦨","🦘","🦡","🐾","🦃","🐔","🐓","🐣","🐤","🐥","🐦","🐧","🕊️","🦅","🦆","🦢","🦉","🦤","🦩","🦚","🦜","🐸","🐊","🐢","🦎","🐍","🐲","🐉","🦕","🦖"]
  },
  {
    category: "Food",
    icon: "🍎",
    emojis: ["🍏","🍎","🍐","🍊","🍋","🍌","🍉","🍇","🍓","🫐","🍈","🍒","🍑","🥭","🍍","🥥","🥝","🍅","🍆","🥑","🥦","🥬","🥒","🌶️","🫑","🌽","🥕","🫒","🧄","🧅","🥔","🍠","🥐","🥯","🍞","🥖","🥨","🧀","🥚","🍳","バター","🧈","🥞","🧇","🥓","🥩","🍗","🍖","🦴","🌭","🍔","🍟","🍕","🥪","🌮","🌯","🥙","🧆","🥘","🍲","🥣","🥗","🍿","🧂","🥫","🍱","🍘","🍙","🍚","🍛","🍜","🍝","🍠","🍢","🍣","🍤","🍥","🥮","🍡","🥟","🥠","🥡","🦀","🦞","🦐","🦑","🦪","🍦","🍧","🍨","🍩","🍪","🎂","🍰","🧁","🥧","🍫","🍬","🍭","🍮","🍯","🍼","🥛","☕","🫖","🍵","🍶","🍾","🍷","🍸","🍹","🍺","🍻","🥂","🥃","🥤","🧋","🧃","🧉","🧊"]
  },
  {
    category: "Activities",
    icon: "⚽",
    emojis: ["⚽","🏀","🏈","⚾","🥎","🎾","🏐","🏉","🥏","🎱","🪀","🏓","🏸","🏒","🏑","🥍","🏏","🥅","⛳","🪁","🏹","🎣","🤿","🥊","🥋","⛸️","🎿","🛷","🛹","🛼","🏋️‍♀️","🏋️","🏋️‍♂️","🤺","🤸‍♀️","🤸","🤸‍♂️","⛹️‍♀️","⛹️","⛹️‍♂️","🤾‍♀️","🤾","🤾‍♂️","🏌️‍♀️","🏌️","🏌️‍♂️","🏇","🧘‍♀️","🧘","🧘‍♂️","🏄‍♀️","🏄","🏄‍♂️","🏊‍♀️","🏊","🏊‍♂️","🤽‍♀️","🤽","🤽‍♂️","🚣‍♀️","🚣","🚣‍♂️","🧗‍♀️","🧗","🧗‍♂️","🚵‍♀️","🚵","🚵‍♂️","🚴‍♀️","🚴","🚴‍♂️","🏆","🥇","🥈","🥉","🏅","🎖️","🏵️","🎫","🎟️","🎭","🎨","🎬","🎤","🎧","🎼","🎹","🥁","🎸","🎻","🎲","♟️","🎯","🎳","🎮","🎰","🧩"]
  },
  {
    category: "Travel",
    icon: "🚗",
    emojis: ["🚗","🚕","🚙","🚌","🚎","🏎️","🚓","🚑","🚒","🚐","🛻","🚚","🚛","🚜","🛵","🏍️","🛺","🚲","🛴","🛹","🚏","🛣️","🛤️","🛢️","⛽","🚨","🚥","🚦","🛑","🚧","⚓","⛵","🛶","🚤","🛳️","⛴️","🛥️","🚢","✈️","🛩️","🛫","🛬","🪂","💺","🚁","🚟","🚠","🚡","🚀","🛸","🛰️","⌛","⏳","⌚","⏰","⏱️","⏲️","🕰️","🕛","🕧","🕐","🕜","🕑","🕝","🕒","🕞","🕓","🕟","🕔","🕠","🕕","🕡","🕖","🕢","🕗","🕣","🕘","🕤","👑"]
  },
  {
    category: "Objects",
    icon: "💡",
    emojis: ["💡", "🔑", "📦", "💻", "🖨️", "🖱️", "⚙️", "🔧", "🔨", "🔋", "🔌", "🛡️", "🔒", "🔓", "🔏", "📝", "📁", "📂", "📌", "📎", "📏", "📐", "📕", "📖", "✉️", "📨", "🔔", "📣", "📋", "📅", "🗑️"]
  },
  {
    category: "Symbols",
    icon: "❤️",
    emojis: ["❤️","🧡","💛","💚","💙","💜","🖤","🤍","🤎","💔","❣️","💕","💞","💓","💗","💖","💘","💝","💟","☮️","✝️","☪️","🕉️","☸️","✡️","🔯","🕎","☯️","☦️","🛐","⛎","♈","♉","♊","♋","♌","♍","♎","♏","♐","♑","♒","♓","🆔","⚛️","🉑","☢️","☣️","📴","📳","🈶","🈚","🈸","🈺","🈷️","✴️","🆚","💮","🉐","㊙️","㊗️","🈴","🈵","🈹","🈲","🅰️","🅱️","🆎","🆑","🅾️","🆘","❌","⭕","🛑","⛔","📛","🚫","💯","💢","♨️","🚷","🚯","🚳","🚱","🔞","📵","🚭","❗","❕","❓","❔","‼️","⁉️","🔅","💡","💤","💦","💨","💫","💬","🗯️","💭","✅","☑️","✔️"]
  }
];

const EMOJI_NAMES = {
  // Smileys & Emotion
  "😀": "grinning smile face happy joy",
  "😃": "grinning face with big eyes happy smile joy",
  "😄": "grinning face with smiling eyes happy smile joy",
  "😁": "beaming face with smiling eyes grin happy smile",
  "😆": "grinning squinting face laughing haha smile",
  "😅": "grinning face with sweat hot relief smile",
  "😂": "face with tears of joy laughing haha cry cry-laughing lol lmao",
  "🤣": "rolling on the floor laughing rofl haha lol lmao",
  "😊": "smiling face with smiling eyes blush happy smile cute",
  "😇": "smiling face with halo angel innocent",
  "🙂": "slightly smiling face happy",
  "🙃": "upside-down face silly crazy",
  "😉": "winking face wink blink eye",
  "😌": "relieved face calm peace",
  "😍": "smiling face with heart-eyes love heart like eye crush",
  "🥰": "smiling face with hearts love heart blush cute warm",
  "😘": "face blowing a kiss kiss love blow",
  "😋": "face savoring food delicious yum yumm mouth tongue",
  "😛": "face with tongue silly joke play",
  "😜": "winking face with tongue silly wink play joke",
  "🤪": "zany face crazy wild goofy",
  "😎": "smiling face with sunglasses cool awesome sun shade",
  "🤩": "star-struck wow amazing star eye",
  "🥳": "partying face party celebrate birthday blower",
  "😏": "smirking face smirk sly",
  "😒": "unamused face meh bored",
  "😞": "disappointed face sad sorry unhappy",
  "😔": "pensive face sad sorrow depressed",
  "😟": "worried face worry anxious",
  "😕": "confused face confuse puzzle",
  "🙁": "slightly frowning face sad unhappy",
  "☹️": "frowning face sad unhappy",
  "😣": "persevering face strain struggle",
  "😖": "confounded face upset",
  "😫": "tired face exhaust sleepy yawn",
  "😩": "weary face tired sigh",
  "🥺": "pleading face beg cute cry puppy eyes mercy",
  "😢": "crying face tear sad weep unhappy",
  "😭": "loudly crying face sob cry sad tears weep lol",
  "😤": "face with steam from nose angry win proud mad",
  "😠": "angry face mad upset cross",
  "😡": "pouting face angry red mad upset furious",
  "🤬": "face with symbols on mouth swear cuss curse angry",
  "🤯": "exploding head mindblown mind blown shock",
  "😳": "flushed face shock blush surprise embarrassed",
  "🥵": "hot face red warm heat sweat",
  "🥶": "cold face blue freeze ice winter shivering",
  "😱": "face screaming in fear scream shock scared horror",
  "😨": "fearful face scared fear anxious",
  "😰": "anxious face with sweat scared sweat panic",
  "😥": "sad but relieved face worry sweat",
  "😓": "downcast face with sweat sad worry sweat",
  "🤗": "hugging face hug warm welcome",
  "🤔": "thinking face think logic question wonder head",
  "🤭": "face with hand over mouth giggle oops laugh",
  "🤫": "shushing face quiet shh silence whisper",
  "🤥": "lying face pinocchio nose lie liar fake",
  "😶": "face without mouth quiet silence",
  "😐": "neutral face meh okay blank",
  "😑": "expressionless face meh flat blank",
  "😬": "grimacing face cringe oops awkward",
  "🙄": "face with rolling eyes eye roll roll bored",
  "😴": "sleeping face sleep zzz night dream",
  "🤤": "drooling face sleep mouth delicious",
  "😪": "sleepy face sleep cry tear tired nose bubble",
  "😵": "dizzy face dead faint shock",
  "🤐": "zipper-mouth face secret silent shh",
  "🤢": "nauseated face sick vomit green",
  "🤮": "face vomiting sick barf throwup green",
  "🤧": "sneezing face sneeze cold flu tissue sick",
  "😷": "face with medical mask doctor sick flu protection",
  "🤒": "face with thermometer sick temperature fever heat",
  "🤕": "face with head-bandage hurt accident head injured",
  "💩": "pile of poop shit turd crap dung brown",
  "😈": "smiling face with horns devil evil demon purple naughty",
  "👿": "angry face with horns devil evil demon purple angry",
  "💀": "skull dead death skeleton bone",
  "👽": "alien extraterrestrial space UFO",
  "👾": "alien monster space invader video game pixel",
  "🤖": "robot face bot technology machine computer",
  "🎃": "jack-o-lantern pumpkin halloween orange",

  // People & Hands
  "👋": "waving hand wave hello hi goodbye bye",
  "👍": "thumbs up like yes ok good correct agree check positive thub",
  "👎": "thumbs down dislike no bad disagree negative",
  "✊": "raised fist power solidarity punch",
  "👊": "oncoming fist punch hit buddy bump fist-bump",
  "🤛": "left-facing fist fist-bump bump",
  "🤜": "right-facing fist fist-bump bump",
  "👏": "clapping hands clap bravo congrats praise",
  "🙌": "raising hands praise celebrate hooray yay",
  "👐": "open hands hug open",
  "🤲": "palms up together pray beg book",
  "🤝": "handshake shake hands deal agree partnership trust",
  "🙏": "folded hands pray please thank you thanks namaste hope wish",
  "✍️": "writing hand write pen pencil sign note",
  "💅": "nail polish manicure fashion beauty polish",
  "🤳": "selfie phone photo camera hand",
  "💪": "flexed biceps muscle strong power fitness gym workout athletic",
  "🧠": "brain mind head think memory intelligence",
  "🦷": "tooth teeth dentist medical oral",
  "👀": "eyes look see watch eye vision spy",
  "👁️": "eye look see watch vision",
  "👄": "mouth lips kiss talk red",

  // Symbols & Hearts
  "❤️": "red heart love like romance passion heart shape red",
  "🧡": "orange heart love like heart shape orange",
  "💛": "yellow heart love like friendship heart shape yellow",
  "💚": "green heart love like heart shape green",
  "💙": "blue heart love like heart shape blue",
  "💜": "purple heart love like heart shape purple",
  "🖤": "black heart love like sad heart shape black",
  "🤍": "white heart love like heart shape white",
  "🤎": "brown heart love like heart shape brown",
  "💔": "broken heart sad split break divorce heartbreak broken-heart",
  "❣️": "heart exclamation love heart red symbol mark",
  "💕": "two hearts love like heart shape pink couple",
  "💞": "revolving hearts love like heart shape pink revolving spin",
  "💓": "beating heart love heart pink beat pulse alive",
  "💗": "growing heart love heart pink grow big",
  "💖": "sparkling heart love heart pink sparkle shine star glitter",
  "💘": "heart with arrow love cupid valentine heart pink arrow",
  "💝": "heart with ribbon love gift present box valentine bow pink",
  "💟": "heart decoration love heart shape purple card",
  "✅": "check mark button check yes ok correct green checkbox ticks tick",
  "☑️": "checkbox check mark yes ok checkbox blue",
  "✔️": "check mark check yes ok black ticks tick",
  "❌": "cross mark no x red delete cancel wrong incorrect multiply",
  "⭕": "heavy large circle red ring zero o",
  "💯": "hundred points 100 score perfect grade exam",
  "🔥": "fire hot flame burn lit popular cool",
  "✨": "sparkles sparkle shine star glitter bright magic",
  "🌟": "glowing star star yellow shine bright gold",
  "⭐": "star yellow gold rank favorite",
  "💬": "speech balloon chat talk comment message text bubble",
  "💭": "thought balloon think dream bubble thought",
};

// Professional outline category icons matching the WhatsApp screenshots exactly
const ClockIcon = () => (
  <svg className="w-[18px] h-[18px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3" />
  </svg>
);

const SmileIcon = () => (
  <svg className="w-[18px] h-[18px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01" />
  </svg>
);

const HandIcon = () => (
  <svg className="w-[18px] h-[18px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0V12m-3-2.5a1.5 1.5 0 013 0M13 6V4.5a1.5 1.5 0 113 0V9m-3-4.5a1.5 1.5 0 013 0M16 7.5V9m-3-1.5a1.5 1.5 0 013 0M16 7.5v-3a1.5 1.5 0 113 0V14c0 3.314-2.686 6-6 6H9.5a5.5 5.5 0 01-5.5-5.5V12a1.5 1.5 0 113 0v2.5M7 14v.01" />
  </svg>
);

const FamilyIcon = () => (
  <svg className="w-[18px] h-[18px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const BearIcon = () => (
  <svg className="w-[18px] h-[18px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 8.5a2.5 2.5 0 115 0M20 8.5a2.5 2.5 0 11-5 0M12 5C6.477 5 2 9.477 2 15c0 4.97 3.636 9.09 8.354 9.878A3 3 0 0112 21h0a3 3 0 011.646 3.878C18.364 24.09 22 19.97 22 15c0-5.523-4.477-10-10-10zM9 13h.01M15 13h.01M12 17a2 2 0 01-2-2h4a2 2 0 01-2 2z" />
  </svg>
);

const PizzaIcon = () => (
  <svg className="w-[18px] h-[18px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3L3 17.5A2 2 0 004.66 21H19.34A2 2 0 0021 17.5L12 3zm-2.5 12a1 1 0 112 0 1 1 0 01-2 0zm5-3a1 1 0 112 0 1 1 0 01-2 0z" />
  </svg>
);

const BuildingIcon = () => (
  <svg className="w-[18px] h-[18px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5" />
  </svg>
);

const LightbulbIcon = () => (
  <svg className="w-[18px] h-[18px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
  </svg>
);

const BallIcon = () => (
  <svg className="w-[18px] h-[18px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 2v20M2 12h20M12 12l5.5-5.5M12 12L6.5 6.5M12 12l5.5 5.5M12 12l-5.5 5.5" />
  </svg>
);

const HashIcon = () => (
  <svg className="w-[18px] h-[18px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 3v18M15 3v18M3 9h18M3 15h18" />
  </svg>
);

const FlagsIcon = () => (
  <svg className="w-[18px] h-[18px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeDasharray="3 3">
    <circle cx="12" cy="12" r="10" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeDasharray="none" d="M8 13.5s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01" />
  </svg>
);

// Map of Outline SVGs matching categories
const CATEGORY_ICONS = {
  Recent: <ClockIcon />,
  Smileys: <SmileIcon />,
  People: <HandIcon />,
  Family: <FamilyIcon />,
  Animals: <BearIcon />,
  Food: <PizzaIcon />,
  Travel: <BuildingIcon />,
  Objects: <LightbulbIcon />,
  Activities: <BallIcon />,
  Symbols: <HashIcon />,
  Flags: <FlagsIcon />
};

// Rich set of the most famous animated memes & GIFs
const FALLBACK_GIFS = [
  { id: "gif_1", url: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExdzNsc2pycGkyY202eWNydGdtbXJrcnNndm8waTNubXdyMHh5M2h4dSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/l41lI4bYV6tbNDOPO/giphy.gif" }, // throwing papers
  { id: "gif_2", url: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExbXNpeDcyczFqazE0czk1YTRuMnkwMmdhN2F2eXJhdG80dHFyZmRraSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/13CoXDiaCcC2EA/giphy.gif" }, // minion screaming
  { id: "gif_3", url: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMnptbzRpbTRhOXdqOHF5ZWxudDNtMTF6eGkycnp3dDJ0NHh5eWk0eiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/26n61r3CT5tQDD02s/giphy.gif" }, // minion celebration
  { id: "gif_4", url: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExdm9iMmNxZmx1MTBkb2U0MHFkMmRxMHFibnNidXcyZWxmdTRodjJrZSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/5GovlcmPQTeKWCU3JM/giphy.gif" }, // minion kissing MUA!
  { id: "gif_5", url: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExZ3NteGFycWdhaWdqdWxmdW84b3pqdmtlNTNyZW5rMndkOHV0MG5uZyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/jUwpNzg9IcyrK/giphy.gif" }, // homer backing into bush
  { id: "gif_6", url: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExOTVjcDliOWtyZjU3MWMxa3Z5Y2c0bWd2M3EydzhhMm0weGFicm54MiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/CuMiNoTRz2DHq/giphy.gif" }, // shrek dancing
  { id: "gif_7", url: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMGxmeDZtOG9oOTUzcTYyeGdodGFid3hhODNmMW8zdnlod3Q2dG41bCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/Z1LYiyIPhnG9O/giphy.gif" }, // cute white cat dancing
  { id: "gif_8", url: "https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExM3hscjJ0czd1ZjZqNHcxejVycWJzYmJtdjY4MGN5cWozZnRxdXhyeSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3o7qDEq2bMbcbPRVP2/giphy.gif" }  // drake nodding yes
];

// Rich custom transparent SVG Stickers organized by Pack (matching user screenshot)
const STICKERS = [
  // Clippy Pack
  {
    id: "clippy_hello",
    name: "Hello there",
    pack: "clippy",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="5" width="90" height="35" rx="10" fill="#fef08a" stroke="#ca8a04" stroke-width="2"/>
      <polygon points="50,40 45,48 55,40" fill="#fef08a" stroke="#ca8a04" stroke-width="2" stroke-linejoin="round"/>
      <text x="50" y="27" font-size="11" font-family="Arial, sans-serif" font-weight="bold" fill="#854d0e" text-anchor="middle">Hello there!</text>
      <path d="M40,55 C40,48 50,48 50,55 L50,80 C50,85 40,85 40,80 L40,65 C40,62 46,62 46,65 L46,75 C46,77 44,77 44,75" fill="none" stroke="#64748b" stroke-width="4" stroke-linecap="round"/>
      <circle cx="43" cy="53" r="4" fill="white" stroke="#334155" stroke-width="1.5"/>
      <circle cx="43" cy="53" r="1.5" fill="black"/>
      <circle cx="51" cy="53" r="4" fill="white" stroke="#334155" stroke-width="1.5"/>
      <circle cx="51" cy="53" r="1.5" fill="black"/>
    </svg>`
  },
  {
    id: "works_robot",
    name: "Works Robot",
    pack: "clippy",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="96" height="28" rx="8" fill="#10b981"/>
      <polygon points="50,30 45,36 55,30" fill="#10b981"/>
      <text x="50" y="18" font-size="7.5" font-family="Courier New, monospace" font-weight="bold" fill="white" text-anchor="middle">WORKS ON MY MACHINE...</text>
      <rect x="35" y="42" width="30" height="25" rx="5" fill="#34d399" stroke="#047857" stroke-width="2"/>
      <circle cx="43" cy="52" r="3.5" fill="#fef08a"/>
      <circle cx="43" cy="52" r="1.5" fill="black"/>
      <circle cx="57" cy="52" r="3.5" fill="#fef08a"/>
      <circle cx="57" cy="52" r="1.5" fill="black"/>
      <line x1="42" y1="60" x2="58" y2="60" stroke="#047857" stroke-width="1.5"/>
      <line x1="46" y1="58" x2="46" y2="62" stroke="#047857" stroke-width="1.5"/>
      <line x1="50" y1="58" x2="50" y2="62" stroke="#047857" stroke-width="1.5"/>
      <line x1="54" y1="58" x2="54" y2="62" stroke="#047857" stroke-width="1.5"/>
      <line x1="50" y1="42" x2="50" y2="36" stroke="#047857" stroke-width="2"/>
      <circle cx="50" cy="35" r="2.5" fill="#f43f5e"/>
    </svg>`
  },

  // Popular Pack
  {
    id: "awesome",
    name: "Awesome Badge",
    pack: "popular",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="45" fill="url(#awesomeGlow)" opacity="0.4"/>
      <path d="M15,35 Q20,15 50,15 Q80,15 85,35 Q90,55 85,75 Q50,90 15,75 Q10,55 15,35 Z" fill="url(#awesomeGrad)" stroke="#c084fc" stroke-width="2"/>
      <text x="50" y="55" font-size="13" font-family="Impact, sans-serif" font-weight="black" fill="white" stroke="#6b21a8" stroke-width="1.5" text-anchor="middle" letter-spacing="1">AWESOME!</text>
      <defs>
        <radialGradient id="awesomeGlow">
          <stop offset="0%" stop-color="#d8b4fe"/>
          <stop offset="100%" stop-color="#d8b4fe" stop-opacity="0"/>
        </radialGradient>
        <linearGradient id="awesomeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#a855f7"/>
          <stop offset="100%" stop-color="#ec4899"/>
        </linearGradient>
      </defs>
    </svg>`
  },
  {
    id: "flame_bee",
    name: "Angry Bee",
    pack: "popular",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <path d="M25,55 C20,35 30,15 50,5 C70,15 80,35 75,55 Z" fill="url(#fireGrad)" opacity="0.85"/>
      <ellipse cx="50" cy="55" rx="22" ry="24" fill="#fbbf24"/>
      <path d="M33,48 Q50,50 67,48" fill="none" stroke="#1e293b" stroke-width="5"/>
      <path d="M29,60 Q50,62 71,60" fill="none" stroke="#1e293b" stroke-width="5"/>
      <polygon points="34,44 42,42 40,36" fill="black"/>
      <polygon points="66,44 58,42 60,36" fill="black"/>
      <circle cx="36" cy="52" r="3" fill="#ef4444"/>
      <circle cx="64" cy="52" r="3" fill="#ef4444"/>
      <ellipse cx="24" cy="46" rx="8" ry="12" fill="#e2e8f0" transform="rotate(-30 24 46)"/>
      <ellipse cx="76" cy="46" rx="8" ry="12" fill="#e2e8f0" transform="rotate(30 76 46)"/>
      <defs>
        <linearGradient id="fireGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stop-color="#ef4444"/>
          <stop offset="50%" stop-color="#f97316"/>
          <stop offset="100%" stop-color="#fbbf24" stop-opacity="0"/>
        </linearGradient>
      </defs>
    </svg>`
  },

  // Office Drama Pack
  {
    id: "highfive",
    name: "High Five",
    pack: "officedrama",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <path d="M25,60 L20,35 C20,32 23,30 25,32 L30,45 L33,30 C34,27 37,27 38,30 L40,48 L43,32 C44,29 47,29 48,32 L49,50 L52,38 C53,35 56,35 57,38 L55,60 C55,65 48,70 40,70 C32,70 25,65 25,60 Z" fill="#38bdf8"/>
      <path d="M75,60 L80,35 C80,32 77,30 75,32 L70,45 L67,30 C66,27 63,27 62,30 L60,48 L57,32 C56,29 53,29 52,32 L51,50 L48,38 C47,35 44,35 43,38 L45,60 C45,65 52,70 60,70 C68,70 75,65 75,60 Z" fill="#facc15"/>
      <path d="M50,20 L50,10 M50,75 L50,85 M20,50 L10,50 M80,50 L90,50" stroke="#f59e0b" stroke-width="3" stroke-linecap="round"/>
    </svg>`
  },
  {
    id: "coffeedemon",
    name: "Cute Demon",
    pack: "officedrama",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="55" r="30" fill="#ef4444"/>
      <path d="M28,35 Q20,25 22,15 Q30,22 34,30 Z" fill="#b91c1c"/>
      <path d="M72,35 Q80,25 78,15 Q70,22 66,30 Z" fill="#b91c1c"/>
      <ellipse cx="40" cy="50" rx="4" ry="6" fill="#fef08a"/>
      <circle cx="40" cy="50" r="1.5" fill="black"/>
      <ellipse cx="60" cy="50" rx="4" ry="6" fill="#fef08a"/>
      <circle cx="60" cy="50" r="1.5" fill="black"/>
      <rect x="42" y="65" width="22" height="18" rx="4" fill="#a855f7" stroke="#6b21a8" stroke-width="1.5"/>
      <path d="M64,69 C68,69 68,79 64,79" fill="none" stroke="#6b21a8" stroke-width="2"/>
    </svg>`
  },

  // Meme Pack
  {
    id: "sloth_yes",
    name: "YES Sloth",
    pack: "meme",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="50" cy="55" rx="25" ry="20" fill="#a18276"/>
      <ellipse cx="40" cy="53" rx="10" ry="7" fill="#6b4c3e" transform="rotate(-10 40 53)"/>
      <ellipse cx="60" cy="53" rx="10" ry="7" fill="#6b4c3e" transform="rotate(10 60 53)"/>
      <circle cx="40" cy="53" r="3.5" fill="black"/>
      <circle cx="60" cy="53" r="3.5" fill="black"/>
      <polygon points="50,60 47,57 53,57" fill="#3b2314"/>
      <path d="M45,63 Q50,66 55,63" fill="none" stroke="#3b2314" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M25,55 C15,45 12,35 15,30 C18,25 25,35 28,45" fill="none" stroke="#a18276" stroke-width="8" stroke-linecap="round"/>
      <path d="M75,55 C85,45 88,35 85,30 C82,25 75,35 72,45" fill="none" stroke="#a18276" stroke-width="8" stroke-linecap="round"/>
      <rect x="35" y="10" width="30" height="15" rx="5" fill="#f43f5e"/>
      <text x="50" y="21" font-size="9" font-family="Arial, sans-serif" font-weight="bold" fill="white" text-anchor="middle">YES!</text>
    </svg>`
  },
  {
    id: "grumpy_cat",
    name: "Grumpy Cat",
    pack: "meme",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <polygon points="25,48 15,20 38,40" fill="#78350f"/>
      <polygon points="75,48 85,20 62,40" fill="#78350f"/>
      <ellipse cx="50" cy="58" rx="28" ry="22" fill="#fef3c7"/>
      <path d="M30,50 C25,58 25,68 35,70 C42,70 45,60 50,60 C55,60 58,70 65,70 C75,68 75,58 70,50 Z" fill="#b45309" opacity="0.85"/>
      <circle cx="38" cy="52" r="6" fill="#38bdf8"/>
      <circle cx="38" cy="52" r="2" fill="black"/>
      <circle cx="62" cy="52" r="6" fill="#38bdf8"/>
      <circle cx="62" cy="52" r="2" fill="black"/>
      <polygon points="50,60 48,58 52,58" fill="#f43f5e"/>
      <path d="M42,67 Q50,62 58,67" fill="none" stroke="#451a03" stroke-width="2" stroke-linecap="round"/>
    </svg>`
  }
];

export default function EmojiPicker({ onSelect, onSelectSticker, onClose }) {
  const [activeTab, setActiveTab] = useState("all"); // 'all' | 'emoji' | 'gif' | 'sticker'
  const [searchQuery, setSearchQuery] = useState("");
  const [activeEmojiCategory, setActiveEmojiCategory] = useState("Smileys");
  const [giphyGifs, setGiphyGifs] = useState([]);
  const [gifsLoading, setGifsLoading] = useState(false);
  const [selectedStickerPack, setSelectedStickerPack] = useState("all"); // 'all' | 'popular' | 'clippy' | 'officedrama' | 'meme'

  const ref = useRef(null);
  const scrollContainerRef = useRef(null);
  const isScrollingRef = useRef(false);

  // Close when clicked outside
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose?.();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  // Load animated GIFs via Giphy public API
  const fetchGifs = useCallback(async (query = "") => {
    setGifsLoading(true);
    try {
      const apiKey = "dc6zaTOxFJmzC"; // Public beta key
      const limit = 12;
      const url = query.trim() 
        ? `https://api.giphy.com/v1/gifs/search?api_key=${apiKey}&q=${encodeURIComponent(query)}&limit=${limit}`
        : `https://api.giphy.com/v1/gifs/trending?api_key=${apiKey}&limit=${limit}`;

      const res = await fetch(url);
      const payload = await res.json();
      if (payload.data && payload.data.length > 0) {
        const formatted = payload.data.map(item => ({
          id: item.id,
          url: item.images.fixed_height_downsampled.url || item.images.original.url
        }));
        setGiphyGifs(formatted);
      } else {
        setGiphyGifs(FALLBACK_GIFS);
      }
    } catch (err) {
      console.warn("Giphy API lookup failed, loading fallback gifs:", err);
      setGiphyGifs(FALLBACK_GIFS);
    } finally {
      setGifsLoading(false);
    }
  }, []);

  // Update GIFs when active tab changes to 'all' or 'gif'
  useEffect(() => {
    if (activeTab === "gif" || activeTab === "all") {
      fetchGifs(searchQuery);
    }
  }, [activeTab, searchQuery, fetchGifs]);

  // Helpers to get data URI for SVGs
  const getSvgDataUri = (svgString) => {
    const cleaned = svgString.replace(/\r?\n|\r/g, '').trim();
    return `data:image/svg+xml;utf8,${encodeURIComponent(cleaned)}`;
  };

  // Click handler for stickers/GIFs
  const handleStickerClick = (url) => {
    onSelectSticker?.(url);
    onClose?.();
  };

  // Local storage recent emojis helper
  const getRecentEmojis = () => {
    try {
      const stored = localStorage.getItem("chat_recent_emojis");
      return stored ? JSON.parse(stored) : ["❤️","👍","🙌","😂","😍","🔥","👏"];
    } catch {
      return ["❤️","👍","🙌","😂","😍","🔥","👏"];
    }
  };

  const addRecentEmoji = (emoji) => {
    try {
      const recent = getRecentEmojis();
      const updated = [emoji, ...recent.filter(e => e !== emoji)].slice(0, 16);
      localStorage.setItem("chat_recent_emojis", JSON.stringify(updated));
    } catch {}
  };

  // Filter emojis based on search
  const getFilteredEmojis = () => {
    if (!searchQuery.trim()) return [];
    const q = searchQuery.toLowerCase().trim();
    const results = [];

    EMOJI_DATA.forEach(cat => {
      cat.emojis.forEach(emoji => {
        // 1. Direct match with the emoji symbol itself
        if (emoji === q) {
          results.push(emoji);
          return;
        }

        // 2. Check keyword lookup dictionary
        const keywords = EMOJI_NAMES[emoji];
        if (keywords && keywords.toLowerCase().includes(q)) {
          results.push(emoji);
        }
      });
    });

    return Array.from(new Set(results)).slice(0, 48);
  };

  // ── Auto Category Scroll-Sync Tracker ──
  const handleEmojiScroll = (e) => {
    if (isScrollingRef.current) return;
    const container = e.currentTarget;
    const scrollTop = container.scrollTop;

    let activeCat = "Smileys";

    // Check if Recent section is visible
    const recentEl = container.querySelector("#emoji-sec-Recent");
    if (recentEl) {
      const offsetTop = recentEl.offsetTop - container.offsetTop;
      if (scrollTop >= offsetTop - 10 && scrollTop < offsetTop + recentEl.offsetHeight) {
        setActiveEmojiCategory("Recent");
        return;
      }
    }

    EMOJI_DATA.forEach(cat => {
      const el = container.querySelector(`#emoji-sec-${cat.category}`);
      if (el) {
        const offsetTop = el.offsetTop - container.offsetTop;
        // Track the section closest or currently scroll-aligned
        if (scrollTop >= offsetTop - 20) {
          activeCat = cat.category;
        }
      }
    });

    setActiveEmojiCategory(activeCat);
  };

  // ── Smooth Programmatic Section Scrolling ──
  const handleCategoryIconClick = (category) => {
    isScrollingRef.current = true;
    setActiveEmojiCategory(category);

    const targetEl = scrollContainerRef.current?.querySelector(`#emoji-sec-${category}`);
    if (targetEl && scrollContainerRef.current) {
      const offsetTop = targetEl.offsetTop - scrollContainerRef.current.offsetTop;
      scrollContainerRef.current.scrollTo({
        top: offsetTop,
        behavior: "smooth"
      });
    }

    // Unblock tracking after smooth animation finishes
    setTimeout(() => {
      isScrollingRef.current = false;
    }, 550);
  };

  // Helper to determine tabs of categories shown
  const getCategoryList = () => {
    const list = [];
    if (getRecentEmojis().length > 0) {
      list.push("Recent");
    }
    EMOJI_DATA.forEach(cat => list.push(cat.category));
    return list;
  };

  // Filter stickers based on selected Pack
  const getFilteredStickers = () => {
    let result = STICKERS;
    if (selectedStickerPack !== "all") {
      result = STICKERS.filter(s => s.pack === selectedStickerPack);
    }
    if (searchQuery.trim()) {
      result = result.filter(s => s.name.toLowerCase().includes(searchQuery.toLowerCase()));
    }
    return result;
  };

  return (
    <div
      ref={ref}
      className="
        absolute bottom-full mb-3 right-0 z-[100]
        bg-slate-900 border border-white/10 rounded-2xl shadow-2xl
        w-80 flex flex-col overflow-hidden animate-in fade-in slide-in-from-bottom-2 duration-200
        text-slate-200 select-none
      "
    >
      {/* ── Tabs Navigation ── */}
      <div className="flex border-b border-white/5 bg-slate-950/60 px-2 pt-2">
        {["all", "emoji", "gif", "sticker"].map((tab) => (
          <button
            key={tab}
            onClick={() => { setActiveTab(tab); setSearchQuery(""); setSelectedStickerPack("all"); }}
            className={`
              flex-1 pb-2 text-[11px] font-semibold uppercase tracking-wider transition-all relative
              ${activeTab === tab ? "text-blue-400" : "text-slate-400 hover:text-slate-200"}
            `}
          >
            {tab === "all" ? "All" : tab === "emoji" ? "Emoji" : tab === "gif" ? "GIFs" : "Stickers"}
            {activeTab === tab && (
              <span className="absolute bottom-0 left-1/4 right-1/4 h-0.5 bg-blue-500 rounded-full animate-in fade-in duration-100" />
            )}
          </button>
        ))}
      </div>

      {/* ── Search Bar ── */}
      <div className="px-3 pt-3 pb-2 relative flex items-center">
        <input
          type="text"
          placeholder="Find something fun"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full bg-white/5 border border-white/10 focus:border-blue-500/50 rounded-xl pl-8 pr-3 py-1.5 text-xs outline-none text-slate-200 transition-colors"
        />
        <FiSearch className="absolute left-6 text-slate-500" size={12} />
      </div>

      {/* ── Tabs Content ── */}
      <div className="max-h-[280px] overflow-y-auto flex-1 min-h-[220px]" style={{ scrollbarWidth: "thin" }}>
        
        {/* 1. ALL TAB */}
        {activeTab === "all" && (
          <div className="p-3 space-y-4">
            {/* Emojis Section */}
            <div>
              <div className="flex justify-between items-center mb-2 px-1">
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wide">Emoji</span>
                <button 
                  onClick={() => setActiveTab("emoji")}
                  className="text-[10px] font-semibold text-blue-400 hover:text-blue-300 flex items-center gap-0.5"
                >
                  See all <FiChevronRight size={10} />
                </button>
              </div>
              <div className="grid grid-cols-8 gap-1 bg-white/5 p-2 rounded-xl border border-white/5">
                {["😲", "😢", "😡", "😍", "😎", "👏", "🔥", "👍"].map(emoji => (
                  <button
                    key={emoji}
                    onClick={() => { onSelect?.(emoji); addRecentEmoji(emoji); }}
                    className="text-2xl p-1 hover:bg-white/10 rounded-lg hover:scale-125 duration-100 transition-all text-center"
                    style={{ textShadow: "0 2px 4px rgba(0,0,0,0.3)" }}
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </div>

            {/* GIFs Section */}
            <div>
              <div className="flex justify-between items-center mb-2 px-1">
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wide">GIFs</span>
                <button 
                  onClick={() => setActiveTab("gif")}
                  className="text-[10px] font-semibold text-blue-400 hover:text-blue-300 flex items-center gap-0.5"
                >
                  See all <FiChevronRight size={10} />
                </button>
              </div>
              <div className="grid grid-cols-3 gap-1.5">
                {gifsLoading ? (
                  <div className="col-span-3 text-center py-4 text-slate-500 text-[10px]">Loading funny GIFs...</div>
                ) : (
                  giphyGifs.slice(0, 3).map(gif => (
                    <button
                      key={gif.id}
                      onClick={() => handleStickerClick(gif.url)}
                      className="h-16 w-full rounded-lg overflow-hidden border border-white/5 bg-white/5 hover:border-blue-500/50 hover:scale-[1.03] transition-all"
                    >
                      <img src={gif.url} alt="GIF" className="w-full h-full object-cover" />
                    </button>
                  ))
                )}
              </div>
            </div>

            {/* Stickers Section */}
            <div>
              <div className="flex justify-between items-center mb-2 px-1">
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wide">Stickers</span>
                <button 
                  onClick={() => setActiveTab("sticker")}
                  className="text-[10px] font-semibold text-blue-400 hover:text-blue-300 flex items-center gap-0.5"
                >
                  See all <FiChevronRight size={10} />
                </button>
              </div>
              <div className="grid grid-cols-4 gap-2 bg-white/5 p-2 rounded-xl border border-white/5">
                {STICKERS.slice(0, 4).map(st => (
                  <button
                    key={st.id}
                    onClick={() => handleStickerClick(getSvgDataUri(st.svg))}
                    className="p-1 rounded-xl bg-white/5 border border-white/5 hover:bg-white/10 hover:border-blue-500/50 hover:scale-105 duration-150 transition-all aspect-square flex items-center justify-center overflow-hidden"
                  >
                    <div dangerouslySetInnerHTML={{ __html: st.svg }} className="w-full h-full animate-in zoom-in duration-200" />
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* 2. EMOJI TAB (Auto Scroll Sync Layout) */}
        {activeTab === "emoji" && (
          <div className="relative">
            {searchQuery.trim() ? (
              <div className="p-3 grid grid-cols-8 gap-1">
                {getFilteredEmojis().map(emoji => (
                  <button
                    key={emoji}
                    onClick={() => { onSelect?.(emoji); addRecentEmoji(emoji); }}
                    className="text-2xl p-1.5 rounded-lg hover:bg-white/10 transition-all hover:scale-125 duration-100"
                    style={{ textShadow: "0 2px 4px rgba(0,0,0,0.3)" }}
                  >
                    {emoji}
                  </button>
                ))}
                {getFilteredEmojis().length === 0 && (
                  <span className="col-span-8 text-center text-slate-500 text-[10px] py-4">No matching emojis</span>
                )}
              </div>
            ) : (
              <div 
                ref={scrollContainerRef}
                onScroll={handleEmojiScroll}
                className="p-3 max-h-[220px] overflow-y-auto space-y-4 scroll-smooth"
                style={{ scrollbarWidth: "thin" }}
              >
                {/* Recent Section inside scroll list */}
                {getRecentEmojis().length > 0 && (
                  <div id="emoji-sec-Recent" className="scroll-mt-2">
                    <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wide block mb-2 px-1">Recent</span>
                    <div className="grid grid-cols-8 gap-1">
                      {getRecentEmojis().map((emoji, idx) => (
                        <button
                          key={`recent-${emoji}-${idx}`}
                          onClick={() => { onSelect?.(emoji); addRecentEmoji(emoji); }}
                          className="text-2xl p-1.5 rounded-lg hover:bg-white/10 transition-all hover:scale-125 duration-100"
                          style={{ textShadow: "0 2px 4px rgba(0,0,0,0.3)" }}
                        >
                          {emoji}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* All Groups continuously rendered */}
                {EMOJI_DATA.map(cat => (
                  <div id={`emoji-sec-${cat.category}`} key={cat.category} className="scroll-mt-2">
                    <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wide block mb-2 px-1">
                      {cat.category === "Smileys" ? "Smileys & Emotion" : 
                       cat.category === "People" ? "People & Body" : 
                       cat.category === "Animals" ? "Animals & Nature" : 
                       cat.category === "Food" ? "Food & Drink" : 
                       cat.category === "Travel" ? "Travel & Places" : cat.category}
                    </span>
                    <div className="grid grid-cols-8 gap-1">
                      {cat.emojis.map(emoji => (
                        <button
                          key={emoji}
                          onClick={() => { onSelect?.(emoji); addRecentEmoji(emoji); }}
                          className="text-2xl p-1.5 rounded-lg hover:bg-white/10 transition-all hover:scale-125 duration-100"
                          style={{ textShadow: "0 2px 4px rgba(0,0,0,0.3)" }}
                        >
                          {emoji}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* 3. GIF TAB */}
        {activeTab === "gif" && (
          <div className="p-3">
            <div className="grid grid-cols-3 gap-1.5">
              {gifsLoading ? (
                <div className="col-span-3 text-center py-8 text-slate-500 text-xs">Loading GIFs from Giphy...</div>
              ) : (
                giphyGifs.map(gif => (
                  <button
                    key={gif.id}
                    onClick={() => handleStickerClick(gif.url)}
                    className="h-16 w-full rounded-lg overflow-hidden border border-white/5 bg-white/5 hover:border-blue-500/50 hover:scale-[1.03] transition-all"
                  >
                    <img src={gif.url} alt="GIF" className="w-full h-full object-cover" />
                  </button>
                ))
              )}
            </div>
          </div>
        )}

        {/* 4. STICKERS TAB (Packs Section Integration) */}
        {activeTab === "sticker" && (
          <div className="p-3 space-y-4">
            
            {/* Grid of E2EE stickers */}
            <div>
              <div className="flex justify-between items-center mb-2 px-1">
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wide block">
                  {selectedStickerPack === "all" ? "All Stickers" : `${selectedStickerPack.toUpperCase()} pack`}
                </span>
                {selectedStickerPack !== "all" && (
                  <button 
                    onClick={() => setSelectedStickerPack("all")}
                    className="text-[10px] font-semibold text-blue-400 hover:text-blue-300"
                  >
                    Show all
                  </button>
                )}
              </div>
              <div className="grid grid-cols-4 gap-2 bg-white/5 p-2 rounded-xl border border-white/5">
                {getFilteredStickers().map(st => (
                  <button
                    key={st.id}
                    onClick={() => handleStickerClick(getSvgDataUri(st.svg))}
                    className="p-1 rounded-xl bg-white/5 border border-white/5 hover:bg-white/10 hover:border-blue-500/50 hover:scale-105 duration-150 transition-all aspect-square flex items-center justify-center overflow-hidden"
                    title={st.name}
                  >
                    <div dangerouslySetInnerHTML={{ __html: st.svg }} className="w-full h-full animate-in zoom-in duration-200" />
                  </button>
                ))}
              </div>
            </div>

            {/* Sticker Packs cards */}
            {selectedStickerPack === "all" && !searchQuery.trim() && (
              <div className="space-y-2">
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wide block px-1">Sticker Packs</span>
                <div className="grid grid-cols-2 gap-2">
                  <button 
                    onClick={() => setSelectedStickerPack("popular")}
                    className="bg-white/5 hover:bg-white/10 rounded-xl p-2.5 border border-white/5 flex items-center justify-between transition-all"
                  >
                    <span className="text-[11px] font-semibold text-slate-100">Popular</span>
                    <span className="text-sm">⭐️</span>
                  </button>
                  <button 
                    onClick={() => setSelectedStickerPack("clippy")}
                    className="bg-white/5 hover:bg-white/10 rounded-xl p-2.5 border border-white/5 flex items-center justify-between transition-all"
                  >
                    <span className="text-[11px] font-semibold text-slate-100">Clippy</span>
                    <span className="text-sm">📎</span>
                  </button>
                  <button 
                    onClick={() => setSelectedStickerPack("officedrama")}
                    className="bg-white/5 hover:bg-white/10 rounded-xl p-2.5 border border-white/5 flex items-center justify-between transition-all"
                  >
                    <span className="text-[11px] font-semibold text-slate-100">Office Drama</span>
                    <span className="text-sm">👩‍💼</span>
                  </button>
                  <button 
                    onClick={() => setSelectedStickerPack("meme")}
                    className="bg-white/5 hover:bg-white/10 rounded-xl p-2.5 border border-white/5 flex items-center justify-between transition-all"
                  >
                    <span className="text-[11px] font-semibold text-slate-100">Meme</span>
                    <span className="text-sm">📝</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

      </div>

      {/* ── Bottom Categories Bar (Sync Highlights on Emoji Tab) ── */}
      {activeTab === "emoji" && !searchQuery.trim() && (
        <div className="flex border-t border-white/5 bg-slate-950/60 p-1.5 px-2.5 items-center justify-between overflow-x-auto select-none" style={{ scrollbarWidth: "none" }}>
          {getCategoryList().map(category => (
            <button
              key={category}
              onClick={() => handleCategoryIconClick(category)}
              className={`
                p-1.5 rounded-lg transition-all hover:scale-110 flex items-center justify-center shrink-0
                ${activeEmojiCategory === category ? "bg-blue-500/20 text-blue-400 scale-115" : "text-slate-400 opacity-60 hover:opacity-100"}
              `}
              title={category}
            >
              {CATEGORY_ICONS[category] || <span>😀</span>}
            </button>
          ))}
        </div>
      )}

      {/* ── Powered by GIPHY Footer ── */}
      {(activeTab === "all" || activeTab === "gif") && (
        <div className="px-3 py-1.5 border-t border-white/5 bg-slate-950/40 text-center">
          <p className="text-[8px] text-slate-500">
            GIFs powered by <span className="font-semibold text-white tracking-wider">GIPHY</span> • <a href="https://giphy.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400">View Terms</a>
          </p>
        </div>
      )}
    </div>
  );
}